<app-loading [isLoading]="true" *ngIf="!isAuthorized || !isLoaded"></app-loading>

<div *ngIf="isAuthorized && isLoaded">
    <div class="row">
        <div class="col-sm-12">
            <div class="action-menu pull-right" *ngIf="!loadingError">
                <app-button-status *ngIf="isSaving || isDeleting"></app-button-status>
                <app-add-button (click)='add()' [ngClass]="{'hide':isEditable}"></app-add-button>
                <app-edit-button (click)='edit()' [ngClass]="{'hide':isEditable}"></app-edit-button>
                <app-preview-button (click)='open(course.catalogUrl)' [ngClass]="{'hide':isEditable}">Preview</app-preview-button>
                <!-- <app-open-button (click)="open()" alt='Open Evaluation in Survey Gizmo'></app-open-button> -->
                <!-- <app-delete-button (click)='isDeleting || delete()' [ngClass]="{'hide':isEditable}"></app-delete-button> -->
                <app-save-button (click)='isSaving || save()' [ngClass]="{'hide':!isEditable}"></app-save-button>
                <app-cancel-button (click)='cancel()' [ngClass]="{'hide':!isEditable}"></app-cancel-button>
                <app-help-button (click)="displayHelpMessage=!displayHelpMessage"></app-help-button>
            </div>
        </div>
    </div>

    <app-help-message [ngClass]="{'hide':!displayHelpMessage}"></app-help-message>
    
    <div *ngIf="errorMessage" class="error text-center">{{errorMessage}}</div>

    <div class='row details-body'>
        <div class='col-sm-12'>

            <div *ngIf='errorMsg' class='text-center alert-text'>{{errorMsg}}</div>

            <div class="item" *ngIf="!loadingError">
                
                <div class="type-bar" *ngIf="course.structure.name" [ngClass]='course.structure.name.replace(" ","-").toLowerCase()'></div>

                <div *ngIf='!isEditable'>
                    <div class="font-weight-bold">
                        <div class="pull-right">{{course.id}}</div>
                        {{course.region.displayName}}
                    </div>
                
                    <div class='course font-weight-bold'>{{course.name}}</div>
                
                    <div>
                        <label>Structure</label>
                        {{course.structure.name | titlecase}}
                    </div>
                
                    <div>
                        <label>Status</label>
                        {{course.status.name | titlecase}}
                    </div>
                </div>

                <div [ngStyle]="{'margin-top': !isEditable ? '2.0em' : null}">
                    <app-course></app-course>
                </div>
                
                <div [ngClass]="{'hide':isEditable}">
                    <div style='padding-top:2.0em;'>
                        <app-course-objectives [display]='defaultDisplay'></app-course-objectives>
                    </div>

                    <div style='margin-top: 2.0em;;'>
                        <app-course-sessions [display]='defaultDisplay'></app-course-sessions>
                    </div>
                        
                    <!-- <div style='padding-top:2.0em;'>
                        <app-course-credits [display]='defaultDisplay'></app-course-credits>
                    </div>  -->

                    <div style='padding-top:2.0em;'>
                        <app-course-vendors [display]='defaultDisplay'></app-course-vendors>
                    </div>

                    <div style='margin-top:2.0em;'>
                        <app-course-registrations [display]='defaultDisplay' *ngIf="isAdmin"></app-course-registrations>
                    </div>

                    <!-- <div style='margin-top:2.0em;'>
                        <app-course-evaluation-options [display]='defaultDisplay'></app-course-evaluation-options> 
                    </div> -->
                    <!-- (refreshRegistrations)="onRefreshRegistrations()" (refreshOlr2Registrations)="onRefreshOlr2Registrations()" -->

                    <!-- <div style='margin-top:2.0em;'>
                        <app-communication-options [display]='defaultDisplay'></app-communication-options>
                    </div> -->
                    <!-- [evaluation]='evaluation' -->
                    
                    
                    <!-- <div style='margin-top:2.0em;'>
                        <app-course-certificate-options [display]='defaultDisplay'></app-course-certificate-options>
                    </div>
                    
                    <div style='margin-top:2.0em;'>
                        <app-course-registrations [olr2]="true" [display]='defaultDisplay'></app-course-registrations>
                    </div>

                    <div style='margin-top:2.0em;'>
                        <app-course-logs [display]='defaultDisplay'></app-course-logs>
                    </div> -->
                    
                    <!--         
                        <div style='padding-top:3.0em;'>
                            <course-registration [evaluation]='evaluation' #registrations [olr2]='false' (refreshLogs)="onRefreshLogs()" [display]='false'></course-registration>
                        </div>

                        <div style='padding-top:3.0em;'>
                            <course-registration [evaluation]='evaluation' #olr2Registrations [olr2]='true' (refreshLogs)="onRefreshLogs()" [display]='false'></course-registration>
                        </div>
                        
                        <div style='padding-top:3.0em; padding-bottom: 1.0em;'>
                            <log-records [evaluationId]="evaluation.id" #logs [display]='false'></log-records>
                        </div> 
                    -->
                </div>
            </div>
        </div>
    </div>
</div>